import IconWithButton from './IconWithButton';
import React from 'react';
function VerticalMenu({hover , setStop}){

    const handleMouseEnter = () => {
        hover(true)
        setStop(true)
        console.log('Mouse entered inner');
      };
    
      const handleMouseLeave = () => {
        // setTimeout(()=>{hover(false)},2000)
        hover(false)
         // Function to call on mouse leave
        console.log('Mouse left inner');
      };


return(<>

    <div  
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    style={{padding:"20px", width:"350px", minHeight:"270px" , zIndex:50}}
    className="card">
    <div style={{gap:"40px"}}className={"flex-container"}>
        <IconWithButton text={'Buy bitcoin'}></IconWithButton>
        <IconWithButton text={'Buy bitcoin'}></IconWithButton>

    </div>
    <div style={{paddingTop:'5px'}}/>
    <div style={{gap:"40px"}}className={"flex-container"}>
        <IconWithButton text={'Buy bitcoin'}></IconWithButton>
        <IconWithButton text={'Buy bitcoin'}></IconWithButton>
       
    </div>
    <div style={{paddingTop:'5px'}}/>

    <div style={{paddingTop:'5px'}}/>
    <div style={{gap:"40px"}}className={"flex-container"}>
        <div>
        <h2 className='font-bold text-black text-xl font-montserrat text-coral-red'>
          SMS
        </h2>
        <p className='text-black text-sm font-montserrat text-coral-red'>
          Worldwide text messaging
        </p>
        </div>
        <div>
        <h2 className='font-bold text-black text-xl font-montserrat text-coral-red'>
          Voice
        </h2>
        <p className='text-black text-sm font-montserrat text-coral-red'>
          SIP trunking and api
        </p>
    </div>
    </div>

    <div style={{gap:"40px"}}className={"flex-container"}>
        <div>
        <h2 className='font-bold text-black text-xl font-montserrat text-coral-red'>
          SMS
        </h2>
        <p className='text-black text-sm font-montserrat text-coral-red'>
          Worldwide text messaging
        </p>
        </div>
        <div>
        <h2 className='font-bold text-black text-xl font-montserrat text-coral-red'>
            Voice
        </h2>
        <p className='text-black text-sm font-montserrat text-coral-red'>
        SIP trunking and api
        </p>
    </div>
    </div>
    </div>
   
</>)

}

export default VerticalMenu